var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"addressBody clearfix"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.addresses.length == 0),expression:"addresses.length == 0"}],staticClass:"addressNoData"},[_c('img',{attrs:{"src":require("../assets/imgs/address_no_data.png"),"alt":""}}),_c('p',[_vm._v("暂无收货地址")])]),_c('div',{staticClass:"addressList"},[_c('ul',_vm._l((_vm.addresses),function(address){return _c('li',{key:address.id},[_c('div',{staticClass:"addressListTop"},[_c('div',[_c('p',[_c('i',[_vm._v(_vm._s(address.name))]),_c('i',[_vm._v(_vm._s(address.phone))]),_c('i',{directives:[{name:"show",rawName:"v-show",value:(address.defaultFlag),expression:"address.defaultFlag"}],staticClass:"defaultAddress"},[_vm._v("默认")])]),_c('p',[_vm._v(_vm._s(address.province)+_vm._s(address.city)+_vm._s(address.district)+_vm._s(address.address))])]),_c('router-link',{staticClass:"edit",attrs:{"to":{
                        path:'/prod/user/receiver/add',
                        query:{
                            addressId:address.id,
                            userId:address.accountId,
                            userName:address.name,
                            userTel:address.phone,
                            userProvince:address.province,
                            userProvinceCode:address.provinceCode,
                            userCity:address.city,
                            userCityCode:address.cityCode,
                            userDistrict:address.district,
                            userDistrictCode:address.districtCode,
                            userAddress:address.address
                        }
                    }}},[_c('img',{attrs:{"src":require("../assets/imgs/address_item_edit.png"),"alt":""}})])],1),_c('div',{staticClass:"addressListBottom"},[_c('a',{staticClass:"default",on:{"click":function($event){return _vm.setDefaultAddress(address)}}},[_c('img',{attrs:{"src":address.defaultFlag ? _vm.defaultImg[0] : _vm.defaultImg[1],"alt":""}}),_vm._v(" 设置为默认地址 ")]),_c('a',{staticClass:"delete",on:{"click":function($event){return _vm.deleteAddress(address)}}},[_vm._v(" 删除 ")])])])}),0)]),_c('div',{staticClass:"addressBottom"},[_c('router-link',{staticClass:"addBtn",attrs:{"to":{
            path:'/prod/user/receiver/add',
            query:{
                addressId:'',
                userId:this.userId,
                userName:'',
                userTel:'',
                userProvince:'',
                userProvinceCode:'',
                userCity:'',
                userCityCode:'',
                userDistrict:'',
                userDistrictCode:'',
                userAddress:''
            }
        }}},[_vm._v(" +新建售后地址 ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }